import api from './api';

export interface EmendaPublicaDTO {
  id?: string;
  numeroEmenda?: number;
  exercicio?: number;
  esfera?: string;
  officialCode?: string;
  classification?: string;
  councilorName?: string;
  objectDetail?: string;
  institutionName?: string;
  beneficiaryLocality?: string;
  executingAgency?: string;
  atoNormativoTipo?: string;
  atoNormativoNumero?: string;
  atoNormativoAno?: number;
  atoNormativoUrl?: string;
  funcaoCodigo?: string;
  value?: number;
  valorRecebido?: number;
  status?: string;
  statusCicloVida?: string;
  tipoTransferencia?: string;
  numeroConvenio?: string;
  anoConvenio?: number;
  planoTrabalhoId?: string;
  periodoInicio?: string;
  periodoFim?: string;
  modalidadeInstrumento?: string;
  valorEmpenhado?: number;
  valorLiquidado?: number;
  valorPago?: number;
  saldoExecutar?: number;
  situacaoExecucao?: string;
  dataReferenciaExecucao?: string;
  ultimaAtualizacaoExecucao?: string;
  processoAdministrativoNumero?: string;
  execucaoFinanceira?: ExecucaoFinanceiraPublicaDTO[];
  contratos?: ContratoPublicoDTO[];
  atosLegais?: AtoLegalPublicoDTO[];
  planoTrabalho?: PlanoTrabalhoPublicoDTO;
  documentos?: DocumentoPublicoDTO[];
  evidencias?: EvidenciaPublicaDTO[];
  despesas?: DespesaPublicaDTO[];
  execucaoPorMeta?: { meta?: string; valorPlanejado?: number; valorExecutado?: number }[];
  alcanceMetas?: { meta?: string; quantidadeRealizada?: number; percentualAlcance?: number; meioAfericao?: string }[];
  bens?: { especificacao?: string; quantidade?: number; valorUnitario?: number; valorTotal?: number; documentoTipo?: string; documentoNumero?: string; dataDocumento?: string; situacao?: string }[];
  anexosPrestacao?: { descricao?: string; nome?: string; revisadoEm?: string; url: string; downloadUrl?: string }[];
  prestacaoContas?: PrestacaoContasPublicaDTO | null;
}

export interface DocumentoPublicoDTO {
  tipo?: string;
  nome?: string;
  descricao?: string;
  mimeType?: string;
  tamanhoBytes?: number;
  dataPublicacao?: string;
  url: string;
  downloadUrl?: string;
}

export interface ContratoPublicoDTO {
  instrumento?: 'TERMO_FOMENTO' | 'CONTRATO';
  numero?: string;
  ano?: number;
  vigenciaInicio?: string;
  vigenciaFim?: string;
  assinatura?: string;
  objeto?: string;
  valor?: number;
  processoCompraNumero?: string;
  processoCompraAno?: number;
}

// Situação da prestação de contas (TAEP D.5).
export interface PrestacaoPcPublicaDTO {
  numero?: number;
  tipo?: string;
  protocolo?: string;
  status?: 'ABERTA' | 'FECHADA' | 'AJUSTE_SOLICITADO' | string;
  prazoOriginal?: string;
  prazoFinal?: string;
  prorrogada?: boolean;
  atualizadaEm?: string;
}

export interface PrestacaoContasPublicaDTO {
  situacao?: 'NAO_INICIADA' | 'EM_ANDAMENTO' | 'CONCLUIDA' | string;
  prazoFinal?: string;
  ultimaAtualizacao?: string;
  concluidaEm?: string;
  prestacoes?: PrestacaoPcPublicaDTO[];
}

// Despesa de prestação de contas fechada (TAEP D.3). Sem dados bancários nem CPF.
export interface DespesaPublicaDTO {
  prestacaoProtocolo?: string;
  prestacaoNumero?: number;
  credor?: string;
  credorCnpj?: string;
  tipoDocumentoFiscal?: string;
  numeroDocumentoFiscal?: string;
  dataDocumentoFiscal?: string;
  dataPagamento?: string;
  valor?: number;
  fonteRecurso?: string;
}

export interface EvidenciaPublicaDTO {
  categoria?: string;
  nome?: string;
  descricao?: string;
  dataDocumento?: string;
  dataPublicacao?: string;
  mimeType?: string;
  tamanhoBytes?: number;
  url: string;
  downloadUrl?: string;
}

export interface AtoLegalPublicoDTO {
  natureza?: string;
  numero?: string;
  ano?: number;
  dataPublicacao?: string;
  dataRevogacao?: string;
  ementa?: string;
  linkOficial?: string;


}

export interface ContaEspecificaPublicaDTO {
  banco?: string;
  agencia?: string;
  conta?: string;
}

export interface PlanoTrabalhoPublicoDTO {
  titulo?: string;
  descricao?: string;
  valor?: number;
  status?: string;
  periodoInicio?: string;
  periodoFim?: string;
  modalidade?: string;
  objetoParceria?: string;
  descricaoRealidade?: string;
  formaExecucao?: string;
  aprovadoEm?: string;
  contaEspecifica?: ContaEspecificaPublicaDTO;
  metas?: MetaPublicaDTO[];
}

export interface MetaPublicaDTO {
  titulo?: string;
  descricao?: string;
  valor?: number;
  periodo?: string;
  ordem?: number;
  itens?: ItemPublicoDTO[];
  cronograma?: CronogramaPublicoDTO[];
}

export interface ItemPublicoDTO {
  titulo?: string;
  descricao?: string;
  tipo?: string;
  unidade?: string;
  quantidade?: number;
  periodoInicio?: string;
  periodoFim?: string;
  valorUnitario?: number;
  valor?: number;
}

export interface CronogramaPublicoDTO {
  dataPrevista?: string;
  atividade?: string;
}

export interface ExecucaoFinanceiraPublicaDTO {
  tipo?: string;
  natureza?: string;
  numeroDocumento?: string;
  dataMovimento?: string;
  valor?: number;
  credor?: string;
  descricaoDespesa?: string;
}

export interface ParlamentarResumo {
  slug: string;
  nome: string;
  partido?: string;
  esfera?: string;
  bancada: boolean;
  totalEmendas: number;
}

export interface ExercicioResumo {
  exercicio: number | null;
  totalEmendas: number;
  previsto: number;
  empenhado: number;
  pago: number;
  porStatus: Record<string, number>;
}

export interface DadosPublicosParlamentar {
  biografia?: string | null;
  contatoEmail?: string | null;
  contatoTelefone?: string | null;
  contatoEndereco?: string | null;
  site?: string | null;
  instagram?: string | null;
  facebook?: string | null;
  temFoto: boolean;
  /** Instante da última alteração; serve para renovar a foto em cache. */
  fotoVersao?: number | null;
  /** Só vem na edição (/meu-perfil-publico). */
  slug?: string | null;
}

export interface ParlamentarPerfil extends Omit<ParlamentarResumo, 'totalEmendas'> {
  dadosPublicos?: DadosPublicosParlamentar | null;
  total: ExercicioResumo;
  exercicios: ExercicioResumo[];
}

export interface TransparenciaFiltros {
  parlamentar?: string;
  /** Parte do nome da instituição beneficiária (razão social ou nome fantasia). */
  instituicao?: string;
  exercicio?: number;
  esfera?: string;
  status?: string;
  tipo?: string;
  autor?: string;
  objeto?: string;
  execucao?: string;
}

export interface TransparenciaResponsavel {
  unidade?: string;
  email?: string;
  telefone?: string;
  atoDesignacaoUrl?: string;
}

export interface TransparenciaMetadata {
  responsavel?: TransparenciaResponsavel | null;
  geradoEm?: string;
  ultimaAtualizacao?: string;
  primeiroExercicio?: number;
  ultimoExercicio?: number;
  totalRegistros: number;
}

export interface EmendaPublicaPage {
  items: EmendaPublicaDTO[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface TransparenciaTipoEmenda {
  codigo: string;
  nome: string;
}

export interface TransparenciaTotais {
  totalItems: number;
  previsto: number;
  empenhado: number;
  pago: number;
}

const queryString =(params?: TransparenciaFiltros): string => {
  const query = new URLSearchParams();
  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (value != null && value !== '') query.set(key, String(value));
  });
  const result = query.toString();
  return result ? `?${result}` : '';
};

export const transparenciaService = {
  list: async (params?: TransparenciaFiltros, page = 0, pageSize = 20): Promise<EmendaPublicaPage> => {
    const response = await api.get<EmendaPublicaPage>('/public/emendas', {
      params: { ...params, page, pageSize },
    });
    return response.data;
  },
  tipos: async (): Promise<TransparenciaTipoEmenda[]> => {
    const response = await api.get<TransparenciaTipoEmenda[]>('/public/emendas/tipos');
    return response.data;
  },
  totais: async (params?: TransparenciaFiltros): Promise<TransparenciaTotais> => {
    const response = await api.get<TransparenciaTotais>('/public/emendas/totais', { params });
    return response.data;
  },
  getByOfficialCode: async (officialCode: string): Promise<EmendaPublicaDTO> => {
    const response = await api.get<EmendaPublicaDTO>(`/public/emendas/${encodeURIComponent(officialCode)}`);
    return response.data;
  },
  resolveDocumentUrl: (url: string): string => /^https?:\/\//i.test(url)
    ? url
    : `${api.defaults.baseURL ?? ''}${url}`,
  parlamentares: async (): Promise<ParlamentarResumo[]> => {
    const response = await api.get<ParlamentarResumo[]>('/public/parlamentares');
    return response.data;
  },
  fotoParlamentarUrl: (slug: string, versao?: number | null): string =>
    `${api.defaults.baseURL ?? ''}/public/parlamentares/${encodeURIComponent(slug)}/foto${versao ? `?v=${versao}` : ''}`,
  parlamentar: async (slug: string): Promise<ParlamentarPerfil> => {
    const response = await api.get<ParlamentarPerfil>(`/public/parlamentares/${encodeURIComponent(slug)}`);
    return response.data;
  },
  metadata: async (): Promise<TransparenciaMetadata> => {
    const response = await api.get<TransparenciaMetadata>('/public/emendas/metadados');
    return response.data;
  },
  exportUrl: (format: 'csv' | 'json', params?: TransparenciaFiltros): string =>
    `${api.defaults.baseURL ?? ''}/public/emendas/dados-abertos.${format}${queryString(params)}`,
};
